var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useMemo } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useGetModuleBuilderGridLayoutQuery, useGetModuleBuilderLabelsQuery, useGetModuleBuilderLayoutQuery, useSaveModuleBuilderLayoutMutation, } from "@/store/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faArrowsV, faCheckCircle, faSave, } from "@fortawesome/pro-solid-svg-icons";
import toast from "react-hot-toast";
import { LoaderImage } from "@/utils/loader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AddWidget from "./addWidget";
import { useTranslation } from "react-i18next";
var Field = function (_a) {
    var item = _a.item, index = _a.index, type = _a.type, moduleStrings = _a.moduleStrings, updateItemDefault = _a.updateItemDefault;
    var moduleString = moduleStrings[item.label] || item.vname;
    return (_jsx(Draggable, __assign({ draggableId: "".concat(type, "-").concat(item.name, "-").concat(index), index: index }, { children: function (provided) { return (_jsxs("div", __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { className: "panel__body--list bg-white border border-gray-200 p-1 mb-2 flex justify-between items-center cursor-move text-sm" }, { children: [_jsxs("div", { children: [_jsxs("div", __assign({ className: "field_name" }, { children: [_jsx(FontAwesomeIcon, { icon: faArrowsV }), " ", moduleString] })), _jsx("div", { children: _jsxs("span", { children: ["[", item.name, "]"] }) }), item.comment && (_jsx("div", { children: _jsxs("i", { children: ["(", item.comment, ")"] }) }))] }), type === "active" && (_jsxs("div", { children: [_jsx("input", { type: "checkbox", checked: item.default, onChange: function () {
                                // Assuming you have a method to update the state
                                // This method should update the item within the state
                                // For example: updateItemDefault(item.id, !item.default);
                                updateItemDefault(item.name, !item.default);
                            } }), _jsx("span", { children: "Default" })] }))] }))); } })));
};
export var ListEditor = function (_a) {
    var layoutName = _a.layoutName, packageName = _a.packageName, moduleName = _a.moduleName;
    var navigate = useNavigate();
    var t = useTranslation(["common", "Studio"]).t;
    var actionWidget = useParams().actionWidget;
    var _b = useState([]), availableFields = _b[0], setAvailableFields = _b[1];
    var _c = useState([]), availableFieldsKeep = _c[0], setAvailableFieldsKeep = _c[1];
    var _d = useState([]), activeFields = _d[0], setActiveFields = _d[1];
    var _e = useState([]), moduleStrings = _e[0], setModuleStrings = _e[1];
    var _f = useState(false), isNotificationActive = _f[0], setNotificationActive = _f[1];
    var _g = useState(""), notificationMessage = _g[0], setNotificationMessage = _g[1];
    var _h = useState(""), notificationType = _h[0], setNotificationType = _h[1];
    var _j = useState([]), popupListFields = _j[0], setPopupListFields = _j[1];
    var _k = useState([]), popupSearchFields = _k[0], setPopupSearchFields = _k[1];
    var defaultpopuplist = "popuplist";
    var defaultpopupsearchdefs = "popupsearchdefs";
    var currentLayoutName = actionWidget === defaultpopuplist || actionWidget === defaultpopupsearchdefs
        ? "popupdefs"
        : layoutName;
    var isPopupLayout = currentLayoutName === "popupdefs" &&
        (actionWidget === defaultpopuplist ||
            actionWidget === defaultpopupsearchdefs);
    var popupLayoutKey = actionWidget === defaultpopuplist
        ? "listviewdefs"
        : actionWidget === defaultpopupsearchdefs
            ? "searchdefs"
            : "searchdefs";
    var _l = useGetModuleBuilderGridLayoutQuery({
        moduleName: moduleName,
        layout: currentLayoutName,
        params: {
            package: packageName,
        },
    }), list_fields = _l.data, isLoadFields = _l.isLoading;
    var _m = useSaveModuleBuilderLayoutMutation(), saveModuleBuilderLayoutMutation = _m[0], _o = _m[1], saveData = _o.data, tokenAccessError = _o.error, isSaveLoad = _o.isLoading;
    var getFields = function () { return __awaiter(void 0, void 0, void 0, function () {
        var fields;
        var _a;
        return __generator(this, function (_b) {
            if (list_fields) {
                fields = Object.values((_a = list_fields === null || list_fields === void 0 ? void 0 : list_fields.data) === null || _a === void 0 ? void 0 : _a.fields).map(function (field) { return (__assign(__assign({}, field), { label: field.label || field.vname, default: false })); });
                setAvailableFields(fields);
                setAvailableFieldsKeep(fields);
            }
            return [2 /*return*/];
        });
    }); };
    var _p = useGetModuleBuilderLabelsQuery({
        params: {
            package: "",
            module_name: moduleName,
            selected_lang: "",
            labels: "all",
        },
    }), list_labels = _p.data, isLoadingLabels = _p.isLoading;
    var getModuleStrings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            if (list_labels) {
                setModuleStrings((_a = list_labels === null || list_labels === void 0 ? void 0 : list_labels.data) === null || _a === void 0 ? void 0 : _a.mod_strings);
            }
            return [2 /*return*/];
        });
    }); };
    var _q = useGetModuleBuilderLayoutQuery({
        moduleName: moduleName,
        layout: currentLayoutName,
        params: {
            package: packageName,
        },
    }), list_layout = _q.data, isLoadLayout = _q.isLoading;
    useEffect(function () {
        var _a;
        if (!((_a = list_layout === null || list_layout === void 0 ? void 0 : list_layout.data) === null || _a === void 0 ? void 0 : _a.layout))
            return;
        var layout = list_layout.data.layout;
        if (!isPopupLayout) {
            setActiveFields(list_layout.data.layout);
            return;
        }
        // POPUP layouts
        var popupFields = Array.isArray(layout[popupLayoutKey])
            ? layout[popupLayoutKey]
            : layout
                ? layout
                : [];
        setActiveFields(popupFields);
        setPopupListFields(Array.isArray(layout.listviewdefs) ? layout.listviewdefs : []);
        setPopupSearchFields(Array.isArray(layout.searchdefs) ? layout.searchdefs : []);
    }, [list_layout, popupLayoutKey, isPopupLayout]);
    var saveLayout = function (publish) {
        if (publish === void 0) { publish = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var getVnameFromAvailableFields_1, normalizeFields, content, datatopost, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        getVnameFromAvailableFields_1 = availableFieldsKeep.filter(function (item) {
                            return activeFields === null || activeFields === void 0 ? void 0 : activeFields.some(function (active) { return item.name === active.name; });
                        });
                        normalizeFields = function (fields) {
                            return fields.map(function (item) {
                                var _a;
                                var name = item.name, isDefault = item.default, width = item.width;
                                var matchingField = getVnameFromAvailableFields_1.find(function (field) { return field.name === name; });
                                var column_name = name === "name" ? "NAME" : (_a = matchingField === null || matchingField === void 0 ? void 0 : matchingField.name) === null || _a === void 0 ? void 0 : _a.toUpperCase();
                                var vname = matchingField
                                    ? matchingField.vname
                                    : "LBL_LIST_".concat(column_name);
                                return { name: name, label: vname, default: isDefault, width: width };
                            });
                        };
                        content = void 0;
                        if (isPopupLayout) {
                            if (actionWidget === defaultpopuplist) {
                                content = {
                                    listviewdefs: normalizeFields(activeFields),
                                    searchdefs: normalizeFields(popupSearchFields),
                                };
                            }
                            else if (actionWidget === defaultpopupsearchdefs) {
                                content = {
                                    listviewdefs: normalizeFields(popupListFields),
                                    searchdefs: normalizeFields(activeFields),
                                };
                            }
                        }
                        else {
                            // For normal layouts
                            content = normalizeFields(activeFields);
                        }
                        datatopost = {
                            moduleName: moduleName,
                            layout: currentLayoutName,
                            body: {
                                package: packageName,
                                content: content,
                                publish: publish,
                            },
                        };
                        console.log("data", datatopost, activeFields);
                        return [4 /*yield*/, saveModuleBuilderLayoutMutation({
                                moduleName: moduleName,
                                layout: currentLayoutName,
                                body: {
                                    package: packageName,
                                    content: content,
                                    publish: publish,
                                },
                            }).unwrap()];
                    case 1:
                        _a.sent();
                        toast.success(publish ? "Save & Publish complete" : "Layout saved");
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        toast.error("Layout not saved");
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var saveAndPublishLayout = function () {
        saveLayout(true);
    };
    var handleDragEnd = function (result) {
        if (!result.destination)
            return;
        var sourceList = result.source.droppableId === "available-fields"
            ? filteredFields
            : activeFields;
        var destList = result.destination.droppableId === "available-fields"
            ? filteredFields
            : activeFields;
        var sourceClone = Array.from(sourceList);
        var destClone = Array.from(destList);
        var movedItem = sourceClone.splice(result.source.index, 1)[0];
        if (result.source.droppableId === result.destination.droppableId) {
            //within the same list
            sourceClone.splice(result.destination.index, 0, movedItem);
            if (result.source.droppableId === "available-fields") {
                setAvailableFields(sourceClone);
            }
            else {
                setActiveFields(sourceClone);
            }
        }
        else {
            //from one list to another
            destClone.splice(result.destination.index, 0, movedItem);
            if (result.source.droppableId === "available-fields") {
                setAvailableFields(sourceClone);
                setActiveFields(destClone);
            }
            else {
                setAvailableFields(destClone);
                setActiveFields(sourceClone);
            }
        }
    };
    var _r = useState(0), key = _r[0], setKey = _r[1];
    var updateItemDefault = function (name, newDefaultValue) {
        var updatedFields = activeFields.map(function (item) {
            return item.name === name ? __assign(__assign({}, item), { default: newDefaultValue }) : item;
        });
        setActiveFields(updatedFields);
    };
    useEffect(function () {
        getFields();
        getModuleStrings();
    }, [list_fields, list_labels, list_layout]);
    var _s = useState(false), renderDroppable = _s[0], setRenderDroppable = _s[1];
    var renderDroppableAfterAnimationFrame = function () {
        if (!renderDroppable) {
            requestAnimationFrame(function () {
                setRenderDroppable(true);
            });
        }
    };
    var filteredFields = useMemo(function () {
        return availableFields.filter(function (field) {
            return !(activeFields === null || activeFields === void 0 ? void 0 : activeFields.some(function (activeField) { return activeField.name === field.name; }));
        });
    }, [availableFields, activeFields]);
    var addWidget = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            navigate("addWidget");
            return [2 /*return*/];
        });
    }); };
    var location = useLocation();
    useEffect(function () {
        if (layoutName === "popupdefs" && !actionWidget) {
            var pathParts = location.pathname.split("/").filter(Boolean);
            var parentPath = "/" + pathParts.slice(0, -1).join("/");
            navigate(parentPath, {
                replace: true,
                state: { isOpen: true },
            });
        }
    }, [layoutName, actionWidget, location.pathname, navigate]);
    var showEditor = !actionWidget ||
        actionWidget === defaultpopuplist ||
        actionWidget === defaultpopupsearchdefs ||
        layoutName === "popupdefs";
    if (!showEditor) {
        return _jsx(AddWidget, { module: moduleName });
    }
    else {
        return (_jsx("div", __assign({ 
            // key={`list_${Date.now()}`}
            className: "flex columns max-h-[50vh] overflow-auto" }, { children: _jsxs("div", __assign({ className: "w-full px-5" }, { children: [_jsx("div", __assign({ className: "level head-form-page mb-3" }, { children: _jsxs("div", __assign({ className: "flex flex-row  justify-between" }, { children: [_jsxs("div", __assign({ className: "level-item" }, { children: [_jsxs("button", __assign({ className: "button primary", onClick: function () { return saveLayout(); } }, { children: [_jsx(FontAwesomeIcon, { icon: faSave }), "\u00A0 ", t("LBL_BTN_SAVE", { ns: "Studio" })] })), _jsxs("button", __assign({ className: "button secondary", onClick: saveAndPublishLayout }, { children: [t("LBL_BTN_SAVEPUBLISH", { ns: "Studio" }), " \u00A0", _jsx(FontAwesomeIcon, { icon: faCheckCircle })] }))] })), _jsx("div", __assign({ className: "" }, { children: _jsxs("button", __assign({ className: "button primary", onClick: addWidget }, { children: [_jsx(FontAwesomeIcon, { className: "px-1", icon: faAdd }), t("app.LBL_ADD_WIDGET", { ns: "common" })] })) }))] })) })), _jsx("section", { children: isNotificationActive && (_jsxs("div", __assign({ className: "notification ".concat(notificationType) }, { children: [_jsx("button", { className: "delete button danger", onClick: function () { return setNotificationActive(false); } }), notificationMessage] }))) }), _jsxs("div", __assign({ className: "relative" }, { children: [isSaveLoad && _jsx(LoaderImage, {}), _jsx(DragDropContext, __assign({ onDragEnd: handleDragEnd }, { children: _jsxs("div", __assign({ className: "grid grid-cols-2 gap-4 w-full" }, { children: [_jsxs("div", __assign({ className: "column" }, { children: [_jsx("h2", __assign({ className: "text-xl font-medium mb-2" }, { children: t("app.LBL_AVAILABLE_FIELDS", { ns: "common" }) })), _jsx("div", __assign({ className: "".concat(filteredFields.length === 0 && "border h-96 rounded-md"), role: "list" }, { children: renderDroppable && (_jsx(Droppable, __assign({ droppableId: "available-fields" }, { children: function (provided, snapshot) { return (_jsxs("div", __assign({ ref: provided.innerRef }, provided.droppableProps, { children: [filteredFields.map(function (item, index) { return (_jsx(Field, { index: index, item: item, type: "available", moduleStrings: moduleStrings }, "available-".concat(item.name, "-").concat(index))); }), provided.placeholder, filteredFields.length === 0 && (_jsx("div", __assign({ className: "flex flex-col mb-1 p-1 border-t cursor-move justify-between items-center" }, { children: _jsxs("span", __assign({ className: " text-gray-300" }, { children: [t("app.LBL_DROP_ITEMS_HERE", {
                                                                                ns: "common",
                                                                            }), " ", "..."] })) })))] }))); } }))) })), renderDroppableAfterAnimationFrame()] })), _jsxs("div", __assign({ className: "column" }, { children: [_jsx("h2", __assign({ className: "text-xl font-medium mb-2" }, { children: t("app.LBL_ACTIVE_FIELDS", { ns: "common" }) })), _jsx("div", __assign({ className: "".concat(activeFields.length === 0 && "border h-96 rounded-md"), role: "list" }, { children: _jsxs("div", __assign({ className: "" }, { children: [renderDroppable && (_jsx(Droppable, __assign({ droppableId: "actives-fields" }, { children: function (provided, snapshot) { return (_jsxs("div", __assign({ ref: provided.innerRef }, provided.droppableProps, { children: [activeFields.map(function (item, index) { return (_jsx(Field, { index: index, item: item, type: "active", moduleStrings: moduleStrings, updateItemDefault: updateItemDefault }, "active-".concat(item.name, "-").concat(index))); }), provided.placeholder, activeFields.length === 0 && (_jsx("div", __assign({ className: "flex flex-col mb-1 p-1 border-t cursor-move justify-between items-center" }, { children: _jsxs("span", __assign({ className: " text-gray-300" }, { children: [t("app.LBL_DROP_ITEMS_HERE", {
                                                                                        ns: "common",
                                                                                    }), " ", "..."] })) })))] }))); } }))), renderDroppableAfterAnimationFrame()] })) }))] }))] })) }))] }))] })) })));
    }
};
